import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18next.use(initReactI18next).use(LanguageDetector).use(Backend).init({
  debug: false, //change to see error description on console.
  falback: "pt",
});
